<template>
  <div class="u-button-group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'UButtonGroup',
};
</script>
